import { Suspense } from 'react';
import { Route } from 'react-router-dom';
import { ProtectedRoute, PublicRoute } from '../../Router';
import { TypeRouteConfig } from './routeConfig';

const guardRoute = (route: TypeRouteConfig) => {
  const page = <Suspense>{route.element}</Suspense>;

  if (route.isAuth) {
    return <ProtectedRoute allowedAccountTypes={route.allowedAccountTypes}>{page}</ProtectedRoute>;
  }

  if (route.allowAuthenticated) {
    return page;
  }

  return <PublicRoute>{page}</PublicRoute>;
};

export const renderRoute = (route: TypeRouteConfig) => {
  const element = guardRoute(route);

  if (route.index) {
    return <Route key="index" index element={element} />;
  }

  return (
    <Route key={route.path} path={route.path} element={element}>
      {route.nested?.map(renderRoute)}
    </Route>
  );
};
